import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const PROGRAMME = [
  { time: "8:30–10:00 AM", title: "Arrival, Registration & Coffee", body: "Badge collection and professional headshots as delegates arrive and settle in." },
  { time: "10:00–10:10 AM", title: "Welcome & Room Briefing", body: "Understand the rules, the challenge and how the day will work." },
  { time: "10:10–10:40 AM", title: "The Anatomy of Growth", body: "Opening talk by Dr. Kunle Oparinde on the foundations behind sustainable growth." },
  { time: "10:40 AM–12:00 PM", title: "Simulation One: Operations, Bottlenecks & Scale" },
  { time: "12:00–1:15 PM", title: "Strategic Working Lunch", body: "Eat, connect and take on a short team challenge." },
  { time: "1:15–2:35 PM", title: "Simulation Two: Technology & Market Entry" },
  { time: "2:35–3:30 PM", title: "The Leadership Room", body: "A moderated conversation on decisions, setbacks and building useful things." },
  { time: "3:30–4:00 PM", title: "Closing & Certificates", body: "Wrap up, complete checkout and take the group portrait." },
];

export default function Programme() {
  return (
    <section className="dark" id="programme">
      <img
        className="dark-texture"
        src="https://images.unsplash.com/photo-1742870668961-b3a1721ab483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxkYXJRJTIwZ3JlZW4lMjBtYXJibGUlMjB0ZXh0dXJlJTIwYWJzdHJhY3QlMjBiYWNrZ3JvdW5kJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjUyODIzNnww&ixlib=rb-4.1.0&q=85"
        alt=""
        aria-hidden="true"
        loading="lazy"
      />
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">One focused day</div>
          <h2 className="title">A room built for thinking and doing.</h2>
          <ThemeTag light />
          <p className="intro">
            The programme is designed to keep things moving. Join us at Aurora
            Conference Centre, Osogbo on 30 January 2027.
          </p>
        </Reveal>
        <div className="timeline">
          {PROGRAMME.map((row, i) => (
            <Reveal key={row.time} delay={i * 0.06} className="rowline" data-testid="programme-timeline-step">
              <div className="time">{row.time}</div>
              <div>
                <h3>{row.title}</h3>
                {row.body && <p>{row.body}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
